// export const organization = {
//   routes: [
//     {
//       path: "/organization/asset-group/:id/survey",
//       component: () => import("../organization-asset-group-survey-view"),
//     },
//     {
//       path: "/organization/asset-group/:id/survey/:id/members",
//       component: () => import("../organization-asset-group-survey-members-view"),
//     },
//     {
//       path: "/organization/asset-group/:assetGroupId/survey/:surveyGroupId/results",
//       component: () => import("../organization-asset-group-survey-results-view"),
//     },
//   ],
// };

export const ddo = {
  routes: [
    {
      path: "/ddo/asset-group/:id/survey",
      component: () => import("../ddo-asset-group-survey-view"),
    },
    {
      path: "/ddo/asset-group/:id/survey/:id/members",
      component: () => import("../ddo-asset-group-survey-members-view"),
    },
    {
      path: "/ddo/asset-group/:assetGroupId/survey/:surveyGroupId/results",
      component: () => import("../ddo-asset-group-survey-results-view"),
    },
  ],
};
